import { makeStyles } from "makeStyles";
import { PermissionGroupIna } from "../models";
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { permissionsTableStyles } from "../styles";
import { useState, useMemo } from "react";
import { TableSortOrder, getComparator, SimpleSortableTableHeadProps, SortableTableHead } from "../SortableTableHead";

const useStyles = makeStyles()((theme) => ({
  ...permissionsTableStyles(theme),
  vertCenter: {
    "& td": {
      verticalAlign: "middle"
    }
  },
  assignmentTypeCell: {
    width: "60px",
    padding: "0px"
  }
}));

interface Props {
  inas?: PermissionGroupIna[];
}

const GroupsInas: React.FunctionComponent<Props> = (props) => {
  const { classes } = useStyles();

  const [order, setOrder] = useState<TableSortOrder>("asc");
  const [orderBy, setOrderBy] = useState<keyof PermissionGroupIna>("id");

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof PermissionGroupIna) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const displayRows = useMemo(() => [...(props.inas ?? [])].sort(getComparator(order, orderBy)), [order, orderBy, props.inas]);

  function GroupsInasTableHead({ id, label, className }: SimpleSortableTableHeadProps<PermissionGroupIna>) {
    return (
      <SortableTableHead
        className={className}
        headCell={{
          id,
          label
        }}
        order={order}
        orderBy={orderBy}
        onRequestSort={handleRequestSort}
      />
    );
  }

  return (
    <Box className={classes.childTableContainer}>
      <Table size="small" className={classes.borderedTable}>
        <TableHead>
          <TableRow>
            <GroupsInasTableHead id="inaName" label="INA Name" />
            <GroupsInasTableHead className={classes.assignmentTypeCell} id="forDefault" label="Default" />
            <GroupsInasTableHead className={classes.assignmentTypeCell} id="forNonAssurance" label="Non- Assurance" />
            <GroupsInasTableHead className={classes.assignmentTypeCell} id="forPprp" label="PPRP PR" />
          </TableRow>
        </TableHead>
        <TableBody>
          {displayRows?.map((ina) => (
            <TableRow className={classes.vertCenter} key={ina.id}>
              <TableCell>{ina.inaName}</TableCell>
              <TableCell>{ina.forDefault ? "✅" : "✖️"}</TableCell>
              <TableCell>{ina.forNonAssurance ? "✅" : "✖️"}</TableCell>
              <TableCell>{ina.forPprp ? "✅" : "✖️"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default GroupsInas;
